// NPM
import React from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

function SeatDistributionLegend(props) {
  const parties = useSelector((state) => state.parties.value);
  const partyOrder = useSelector((state) => state.partyOrder.value);

  const renderParty = (partyId) => {
    const party = parties.find((p) => p.id === partyId);
    return (
      <li
        key={`SeatDistributionLegend-party-${partyId}`}
        className="SeatDistributionLegend-party"
      >
        <span
          className="SeatDistributionLegend-party-colour"
          style={{ background: party.color }}
        />
        <span className="SeatDistributionLegend-party-name">{party.short}</span>
      </li>
    );
  };

  const leftParties = _.chain(props.formattedData.leftData)
    .flatMap((group) => {
      return _.flatMap(group, (row) => {
        return row.map((cell) => cell.party);
      });
    })
    .uniq()
    .value();

  const rightParties = _.chain(props.formattedData.rightData)
    .flatMap((group) => {
      return _.flatMap(group, (row) => {
        return row.map((cell) => cell.party);
      });
    })
    .uniq()
    .value();

  if (_.isBlank(partyOrder)) {
    return null;
  }

  const graphParties = [...leftParties, ...rightParties];

  return (
    <ul className="SeatDistributionLegend">
      {_.sortBy(graphParties, (p) => partyOrder.indexOf(p)).map(renderParty)}
    </ul>
  );
}

export default SeatDistributionLegend;
